<template>
   <div class="c-testimonials">
      <div class="page-wrapper c-testimonials__wrapper">
         <carousel :perPageCustom="[[768, 3], [1024, 4]]" :loop="true" :autoplay="true" :navication-enabled="true" :pagination-enabled="true" :pagination-size="12" pagination-active-color="#787878" pagination-color="#cccccc">
            <slide v-for="board in boards">
               <img :src="require('@/assets/boards/us-' + board + '.png')" alt="" class="c-testimonials__image" />
            </slide>
         </carousel>
      </div>
   </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
   components: {
      Carousel,
      Slide,
   },
   data () {
      return {
			boards: ['crmls', 'centris', 'citrus', 'creb', 'mlslistings', 'sabor', 'bcnorthern', 'oc',  'cadreb', 'vreb', 'brrea', 'omreb', 'ssm', 'vail', 'crisnet', 'daor','pwr', 'tricounties']
      }
	},

}
</script>

<style scoped>
	.c-testimonials {  }
	.c-testimonials__wrapper { overflow: hidden; padding: 50px 0 30px; text-align: center; }
	.c-testimonials__image { max-width: 175px; }
</style>
